import { render, staticRenderFns } from "./arquivo.vue?vue&type=template&id=2e257b0d&scoped=true"
import script from "./arquivo.vue?vue&type=script&lang=js"
export * from "./arquivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e257b0d",
  null
  
)

export default component.exports